import { PML } from "@/pixels/providers/pml";
import { getParameterByName } from "@/utils";
import { matchesTCode } from "@/pixels/utils/helpers";

jest.mock("@/utils", () => ({
  getParameterByName: jest.fn()
}));

jest.mock("@/pixels/utils/helpers", () => ({
  matchesTCode: jest.fn()
}));

describe("Módulo PML", () => {
  const log = {
    error: jest.fn(),
    log: jest.fn()
  };

  beforeEach(() => {
    getParameterByName.mockReset();
    jest.fn(() => ({ name: "dev" })), // Mock de getEnvironment
      matchesTCode.mockReset();
    log.error.mockReset();
    log.log.mockReset();

    global.console = {
      error: jest.fn(),
      log: jest.fn()
    };
  });

  const contextoSimulado = {
    state: {
      dataOferta: {
        nroDeTramite: "123456",
        oferta: {
          numeroCliente: "789012"
        }
      },
      paquetesBeneficios: {
        caracteristicas: {
          tipoPaquete: "01"
        }
      }
    }
  };

  it("debe enviar solicitud de seguimiento cuando existe clickID", async () => {
    const clickID = "click123";
    matchesTCode.mockImplementation((codes, callback) => callback());
    getParameterByName.mockReturnValue(clickID);

    global.fetch = jest.fn(() => Promise.resolve());

    await PML.enviar(contextoSimulado);

    expect(fetch).toHaveBeenCalledWith(
      `https://www.w4gb0ubgf.com/?nid=3280&adv1=${contextoSimulado.state.dataOferta.nroDeTramite}&adv2=${contextoSimulado.state.dataOferta.oferta.numeroCliente}&transaction_id=${clickID}`,
      {
        method: "GET"
      }
    );
  });

  it("no debe enviar solicitud de seguimiento si falta clickID", async () => {
    matchesTCode.mockImplementation((codes, callback) => callback());
    getParameterByName.mockReturnValue(null);

    global.fetch = jest.fn(() => Promise.resolve());

    await PML.enviar(contextoSimulado);

    expect(fetch).not.toHaveBeenCalled();
  });

  it("no debe enviar solicitud de seguimiento si el TCode no coincide", async () => {
    matchesTCode.mockImplementation(() => {
      /* no llamar callback */
    });
    getParameterByName.mockReturnValue("click123");

    global.fetch = jest.fn(() => Promise.resolve());

    await PML.enviar(contextoSimulado);

    expect(fetch).not.toHaveBeenCalled();
  });

  it("debe enviar solicitud de oferta PQ cuando existe clickID", async () => {
    const clickID = "click123";
    matchesTCode.mockImplementation((codes, callback) => callback());
    getParameterByName.mockReturnValue(clickID);

    global.fetch = jest.fn(() => Promise.resolve());

    await PML.enviarOfertaPq(contextoSimulado);

    expect(fetch).toHaveBeenCalledWith(
      `https://www.w4gb0ubgf.com/?nid=3280&adv1=${contextoSimulado.state.dataOferta.nroDeTramite}&adv2=${contextoSimulado.state.dataOferta.oferta.numeroCliente}&transaction_id=${clickID}&event_id=25`,
      {
        method: "GET"
      }
    );
  });

  it("no debe enviar solicitud de oferta PQ si falta clickID", async () => {
    matchesTCode.mockImplementation((codes, callback) => callback());
    getParameterByName.mockReturnValue(null);

    global.fetch = jest.fn(() => Promise.resolve());

    await PML.enviarOfertaPq(contextoSimulado);

    expect(fetch).not.toHaveBeenCalled();
  });

  it("no debe enviar solicitud de oferta PQ si no hay paquete", async () => {
    const contextoSinPaquete = {
      ...contextoSimulado,
      state: {
        ...contextoSimulado.state,
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: null
          }
        }
      }
    };

    matchesTCode.mockImplementation((codes, callback) => callback());
    getParameterByName.mockReturnValue("click123");

    global.fetch = jest.fn(() => Promise.resolve());

    await PML.enviarOfertaPq(contextoSinPaquete);

    expect(fetch).not.toHaveBeenCalled();
  });
});
